/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import HeaderIcon from './HeaderIcon';

type Props = {
  link: string,
  label?: string,
  tooltip?: string,
};

const BookmarkFallBack = ({
  link,
  label,
  tooltip,
}: Props): React$MixedElement => {
  return (
    <HeaderIcon
      link={link}
      icon="bookmark-line"
      iconFilled="bookmark-solid"
      label={label || t('Merkliste')}
      labelId="header-icon-label--bookmark"
      tooltip={tooltip || t('Merkliste')}
    />
  );
};

export default BookmarkFallBack;
